import { render, staticRenderFns } from "./OrderTradeForm.vue?vue&type=template&id=7d714d1a&scoped=true"
import script from "./OrderTradeForm.vue?vue&type=script&lang=js"
export * from "./OrderTradeForm.vue?vue&type=script&lang=js"
import style0 from "./OrderTradeForm.vue?vue&type=style&index=0&id=7d714d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d714d1a",
  null
  
)

export default component.exports